<template>
  <br/>
  <br/>
  <br/>
  <div class="alert alert-danger">اطلاعات حساب کاربری شما یافت نشد. لطفا از برنامه خارج شده و مجددا وارد شوید. در صورت تکرار مشکل با پشتیبانی تماس بگیرید.</div>
  <br/>
  <br/>
</template>

<script>
export default {
name: "UserNotFound"
}
</script>

<style scoped>

</style>